"use client"

import { useState, useEffect } from "react"
import { Card } from "antd"

export default function ModernTemplate({ cart: cartProp }) {
  const cart = cartProp || { items: [], total: 0, paid: 0, salesRepName: "" };

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Calculate totalItems and total from cart.items
  const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
  const total = cart.items.reduce((sum, item) => {
    const price = item.price || 0;
    const quantity = item.quantity || 1;
    return sum + (price * quantity);
  }, 0);

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(to bottom right, #0F172A, #1E3A8A, #4F46E5)",
        padding: 24,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Animated Background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-10rem",
            right: "-10rem",
            width: "20rem",
            height: "20rem",
            background: "rgba(59, 130, 246, 0.2)",
            borderRadius: "50%",
            filter: "blur(48px)",
            animation: "pulse 6s infinite",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            bottom: "-10rem",
            left: "-10rem",
            width: "20rem",
            height: "20rem",
            background: "rgba(168, 85, 247, 0.2)",
            borderRadius: "50%",
            filter: "blur(48px)",
            animation: "pulse 6s infinite",
          }}
        ></div>
      </div>

      <div
        style={{
          position: "relative",
          zIndex: 10,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header with Time */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <div>
            <h1
              style={{
                fontSize: 36,
                fontWeight: "bold",
                background: "linear-gradient(to right, #60A5FA, #A855F7)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Smart Order Display
            </h1>
            <p
              style={{
                color: "#9CA3AF",
                marginTop: 4,
              }}
            >
              Real-time synchronization active
            </p>
          </div>
          <div
            style={{
              textAlign: "right",
            }}
          >
            <div
              style={{
                fontSize: 24,
                fontFamily: "monospace",
                color: "#FFFFFF",
              }}
            >
              {time.toLocaleTimeString()}
            </div>
            <div
              style={{
                fontSize: 14,
                color: "#9CA3AF",
              }}
            >
              {time.toLocaleDateString()}
            </div>
          </div>
        </div>

        {/* Main Grid */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 24,
          }}
          className="lg:grid-cols-4"
        >
          {/* Stats Panel */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <Card
              style={{
                background: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(4px)",
              }}
              styles={{ body: {
                padding: 16,
                textAlign: "center",
              } }}
            >
              <div
                style={{
                  fontSize: 30,
                  fontWeight: "bold",
                  color: "#60A5FA",
                }}
              >
                {totalItems}
              </div>
              <div
                style={{
                  fontSize: 14,
                  color: "#9CA3AF",
                }}
              >
                Items
              </div>
            </Card>

            <Card
              style={{
                background: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(4px)",
              }}
              styles={{ body: {
                padding: 16,
                textAlign: "center",
              } }}
            >
              <div
                style={{
                  fontSize: 30,
                  fontWeight: "bold",
                  color: "#34D399",
                }}
              >
                ${isNaN(total) ? "0.00" : total.toFixed(2)}
              </div>
              <div
                style={{
                  fontSize: 14,
                  color: "#9CA3AF",
                }}
              >
                Total
              </div>
            </Card>

            <Card
              style={{
                background: "linear-gradient(to bottom right, rgba(34, 197, 94, 0.2), rgba(16, 185, 129, 0.2))",
                border: "1px solid rgba(34, 197, 94, 0.3)",
              }}
              styles={{ body: {
                padding: 16,
                textAlign: "center",
              } }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    background: "#34D399",
                    borderRadius: "50%",
                    animation: "pulse 2s infinite",
                  }}
                ></div>
                <span
                  style={{
                    color: "#34D399",
                    fontSize: 14,
                    fontWeight: "600",
                  }}
                >
                  LIVE
                </span>
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "#D1D5DB",
                }}
              >
                Real-time Updates
              </div>
            </Card>
          </div>

          {/* Order Display */}
          <div
            style={{
              gridColumn: "span 1 / span 1",
            }}
            className="lg:col-span-3"
          >
            <Card
              style={{
                height: "100%",
                background: "rgba(255, 255, 255, 0.05)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(4px)",
              }}
              styles={{ body: {
                padding: 24,
                height: "100%",
                display: "flex",
                flexDirection: "column",
              } }}
            >
              <h2
                style={{
                  fontSize: 24,
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  marginBottom: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: 32,
                    height: 32,
                    background: "linear-gradient(to right, #3B82F6, #A855F7)",
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 12,
                  }}
                >
                  🛒
                </span>
                Current Order
              </h2>

              {cart.items.length === 0 ? (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: 128,
                      height: 128,
                      background: "linear-gradient(to bottom right, rgba(59, 130, 246, 0.2), rgba(168, 85, 247, 0.2))",
                      borderRadius: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 24,
                      animation: "pulse 6s infinite",
                    }}
                  >
                    <span style={{ fontSize: 64 }}>⏳</span>
                  </div>
                  <h3
                    style={{
                      fontSize: 20,
                      fontWeight: "600",
                      color: "#FFFFFF",
                      marginBottom: 8,
                    }}
                  >
                    Waiting for items...
                  </h3>
                  <p
                    style={{
                      color: "#9CA3AF",
                      textAlign: "center",
                    }}
                  >
                    Your order will appear here in real-time
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: 16,
                      overflowY: "auto",
                    }}
                  >
                    {cart.items.map((item, index) => (
                      <div
                        key={item.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 16,
                          padding: 16,
                          background: "rgba(255, 255, 255, 0.05)",
                          borderRadius: 12,
                          border: "1px solid rgba(255, 255, 255, 0.1)",
                          transition: "background 0.3s",
                        }}
                        className="item-animation"
                        data-index={index}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)")}
                      >
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <img
                            src={item.image}
                            alt={item.name}
                            style={{
                              width: 64,
                              height: 64,
                              objectFit: "cover",
                              borderRadius: 8,
                            }}
                            onError={(e) => (e.target.src = "/placeholder.svg?height=60&width=60")} // Fallback on image load error
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: -8,
                              right: -8,
                              width: 24,
                              height: 24,
                              background: "linear-gradient(to right, #F97316, #EF4444)",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#FFFFFF",
                              fontSize: 12,
                              fontWeight: "bold",
                            }}
                          >
                            {item.quantity}
                          </div>
                        </div>
                        <div
                          style={{
                            flex: 1,
                          }}
                        >
                          <h3
                            style={{
                              fontSize: 18,
                              fontWeight: "600",
                              color: "#FFFFFF",
                            }}
                          >
                            {item.name}
                          </h3>
                          <p
                            style={{
                              fontSize: 14,
                              color: "#9CA3AF",
                            }}
                          >
                            ${(item.price || 0).toFixed(2)} each
                          </p>
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              background: "linear-gradient(to right, #34D399, #10B981)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            ${((item.price || 0) * (item.quantity || 1)).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      marginTop: 24,
                      paddingTop: 24,
                      borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: "600",
                          color: "#FFFFFF",
                        }}
                      >
                        Total Amount
                      </span>
                      <span
                        style={{
                          fontSize: 30,
                          fontWeight: "bold",
                          background: "linear-gradient(to right, #34D399, #10B981)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        ${isNaN(total) ? "0.00" : total.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style jsx global>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.1);
          }
        }
        .item-animation {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.5s ease forwards;
        }
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .item-animation[data-index="0"] { animation-delay: 0s; }
        .item-animation[data-index="1"] { animation-delay: 0.1s; }
        .item-animation[data-index="2"] { animation-delay: 0.2s; }
        .item-animation[data-index="3"] { animation-delay: 0.3s; }
        .item-animation[data-index="4"] { animation-delay: 0.4s; }
        .item-animation[data-index="5"] { animation-delay: 0.5s; }
        .item-animation[data-index="6"] { animation-delay: 0.6s; }
      `}</style>
    </div>
  )
}